import { render } from "./AccountUserDetail.vue?vue&type=template&id=a40dab84"
import script from "./AccountUserDetail.vue?vue&type=script&lang=js"
export * from "./AccountUserDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__